import axios from 'axios';

export type SanctionsSource = 'EU' | 'OFAC' | 'UK';

export type SanctionsResult = {
  id: string;
  primaryName: string;
  aliases: string[];
  entityType: 'person' | 'entity' | 'unknown';
  source: SanctionsSource;
  programs: string[];
  country: string;
  remarks: string;
};

export type SanctionsStatusInfo = {
  loading: boolean;
  lastRefresh: string | null;
  ready: boolean;
  sources: {
    eu: number;
    ofac: number;
    uk: number;
  };
};

export type PersonSanctionsMatch = {
  personName: string;
  functions: string[];
  functionsSwedish: string[];
  sanctionsMatches: SanctionsResult[];
};

export type PersonSearchResult = {
  persons: PersonSanctionsMatch[];
  searchedCount: number;
  source: string | null;
  error?: string;
};

export type SanctionsSearchResponse = {
  results: SanctionsResult[];
  query: string;
  status: SanctionsStatusInfo;
  personResult?: PersonSearchResult;
};

export type SanctionsStatus = {
  lastRefresh: string | null;
  euCount: number;
  ofacCount: number;
  ukCount: number;
  loading: boolean;
  ready: boolean;
  errors: { source: string; error: string }[];
};

class ServiceSanctions {
  search = async (query: string, orgNumber?: string, limit?: number): Promise<SanctionsSearchResponse> => {
    const response = await axios.get('/api/sanctions/search', {
      params: { companyName: query, orgNumber, limit },
    });
    return response.data;
  };

  getStatus = async (): Promise<SanctionsStatus> => {
    const response = await axios.get('/api/sanctions/status');
    return response.data;
  };
}

export default new ServiceSanctions();
